// extracted by mini-css-extract-plugin
module.exports = {"capabilitiesTable":"LimitationList__capabilitiesTable___2wbAa","limitationsTable":"LimitationList__limitationsTable___1TOco"};